import React from 'react'
import classNames from 'classnames'
import { AiResult, StructuredSummaryResultType } from '../../../../../../../models/AiResult'
import { AiFeature } from '../../../../../../../models/AiFeature'
import { StructuredSummaryMeetingResultEditView } from './StructuredSummaryMeetingResultEditView'
import { getSafeValueOnPath } from '../../../utils'

interface EditableMapMeetingResultProps {
  aiFeature: AiFeature
  aiResult: AiResult
  basePath: string
  path: string
  onResultTextContentChange: (basePath: string, path: string, resultTextContent: string | boolean) => void
  onFormattedResultChange: (basePath: string, path: string, contentType: string, content: string) => void
}

export const EditableMapMeetingResult: React.FC<EditableMapMeetingResultProps> = ({
  aiResult,
  aiFeature,
  basePath,
  path,
  onResultTextContentChange,
  onFormattedResultChange,
}) => {
  const result: { [key: string]: StructuredSummaryResultType | StructuredSummaryResultType[] } =
    getSafeValueOnPath(getSafeValueOnPath(aiResult.result, basePath), path, {}) ?? {}

  const hasMapValue = Object.values(result).some((result: StructuredSummaryResultType) =>
    Array.isArray(result) ? result.some((arrayValue) => typeof arrayValue === 'object') : typeof result === 'object',
  )

  return (
    <>
      {Object.entries(result).map(([key, value], idx) => {
        return (
          <div className={classNames('d-flex flex-column gap-1 py-1', { 'map-result-divider': hasMapValue })} key={`map_${idx}`}>
            <div
              className={classNames({
                'lead-small': !hasMapValue,
                'paragraph-large bold mb-3': hasMapValue,
              })}
            >
              {key}
            </div>
            <StructuredSummaryMeetingResultEditView
              aiResult={aiResult}
              aiFeature={aiFeature}
              basePath={basePath}
              path={`${path}["${key}"]`}
              onResultTextContentChange={onResultTextContentChange}
              onFormattedResultChange={onFormattedResultChange}
            />
          </div>
        )
      })}
    </>
  )
}
